var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 146,
    viewBox: "0 0 94 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0327 12.2871C71.074 4.3916 59.6679 0.457936 45.8113 0.489446L22.8301 0.515482L22.8341 2.22493L45.8152 2.1989C55.017 2.178 61.0545 5.2387 63.9239 11.384C66.6863 17.0725 68.0863 27.0926 68.1188 41.444C68.1515 55.7972 66.7972 65.8234 64.0608 71.5244C61.219 77.6813 55.1956 80.7709 45.9939 80.7918L34.5861 80.8176L34.5899 82.5256L45.9977 82.4997C59.8543 82.4682 71.2425 78.4858 80.1652 70.5481C89.0848 62.6118 93.5324 52.8913 93.5062 41.3865C93.4802 29.8845 88.9884 20.1826 80.0327 12.2871Z",
    fill: "#799CA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2976 87.4082C28.3223 98.2578 26.6994 108.447 23.2258 118.42C20.7753 125.511 16.478 134.601 10.5389 145.464L10.9223 133.284C11.1158 127.969 11.1044 122.877 11.0931 118.006C11.0095 81.0268 6.42178 53.58 0.417969 35.878L16.3775 0.635742C20.1072 12.3641 23.017 26.5279 25.1125 43.1308C26.9974 58.6269 28.0603 73.4608 28.2976 87.4082Z",
    fill: "#3A485B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b600a299a92593b1f4a76fe50747e0d.svg";
export { ForwardRef as ReactComponent };